export interface Post {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string; // ISO or readable
  readTime: string;
  image: string;
  slug: string;
  popular?: boolean;
}

export const samplePosts: Post[] = [
  {
    id: "p1",
    title: "How AI Hackathons Accelerate Real-World Innovation",
    excerpt: "From idea to prototype in 48 hours: tactics to get traction fast.",
    category: "Founder Stories",
    date: "2025-08-01",
    readTime: "5 min read",
    image: "/lovable-uploads/2c6d0f6b-9b78-45c3-bab7-cb8582451d54.png",
    slug: "ai-hackathons-accelerate-innovation",
    popular: true,
  },
  {
    id: "p2",
    title: "Investor Insights: What VCs Look For at Hackathons",
    excerpt: "Signals that matter: team, velocity, and clear problem framing.",
    category: "Investor Insights",
    date: "2025-07-28",
    readTime: "6 min read",
    image: "/lovable-uploads/cf02a18e-674f-4c14-9c47-702730aa68ed.png",
    slug: "what-vcs-look-for",
    popular: true,
  },
  {
    id: "p3",
    title: "Pitch Tips: Crafting a 3-Minute Demo That Wins",
    excerpt: "A simple structure for crisp demos investors remember.",
    category: "Pitch Tips",
    date: "2025-07-20",
    readTime: "4 min read",
    image: "/lovable-uploads/e5bffe1a-5098-4df1-9be5-e8c191dad6c4.png",
    slug: "crafting-a-winning-demo",
    popular: true,
  },
  {
    id: "p4",
    title: "Timeline: Your First 24 Hours at AI4Hack",
    excerpt: "A playbook for forming a team, validating, and shipping.",
    category: "Fundraising Advice",
    date: "2025-08-05",
    readTime: "7 min read",
    image: "/lovable-uploads/b94bb676-a852-48ba-a306-fcaa049bb14c.png",
    slug: "first-24-hours-ai4hack",
  },
  {
    id: "p5",
    title: "Global Events: Building Across Timezones",
    excerpt: "How remote-first teams collaborate under pressure.",
    category: "Global Events",
    date: "2025-07-15",
    readTime: "5 min read",
    image: "/lovable-uploads/4bb69d0d-8981-4057-9c22-52be57947bcc.png",
    slug: "building-across-timezones",
  },
  {
    id: "p6",
    title: "Founder Story: From Hack to Seed Round",
    excerpt: "Lessons from the journey after the demo day.",
    category: "Founder Stories",
    date: "2025-06-30",
    readTime: "8 min read",
    image: "/lovable-uploads/8e561a49-de28-4b66-b267-0fb33bf4f7eb.png",
    slug: "from-hack-to-seed",
  },
];
